import React, { useState } from "react"
import axios from "axios"
import qs from "qs"

import RichText from "./RichText"
import Button from "./Button"

import styles from "./emailCapture.module.scss"
import { trackEvent } from "../helpers"


const EmailCapture = props => {
  const {
    heading,
    text,
    submitText,
    disclaimerText,
    confirmationHeading,
    confirmationText,
    confirmationCta,
    listId,
    source,
    formName,
    captureSource,
    captureTrafficSource,
    captureLocation,
    offerDiscountCode,
    location,
    closeModal,
  } = props

  const confirmationTexts = confirmationText.split("<discount>")

  const [email, setEmail] = useState("")
  const [success, setSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [discountCode, setDiscountCode] = useState(null)

  const submitEmail = e => {
    e.preventDefault()

    const parsedQuery = qs.parse(location.search, { ignoreQueryPrefix: true })

    axios({
      url: "https://l.tamaramellon.com/api/email/subscribe",
      method: "post",
      data: {
        "g": listId,
        "email": email,
        "$timezone_offset": (new Date()).getTimezoneOffset()/-60,
        "$fields": "Newsletter_Signup_Location, form_name, capture_consent, capture_source, capture_trafficsource, capture_location, capture_medium, capture_campaign",
        "Newsletter_Signup_Location": source,
        "form_name": formName,
        "capture_consent": "email, web, mobile, sms, chat, directmail",
        "capture_source": captureSource || parsedQuery["utm_source"] || "",
        "capture_trafficsource": captureTrafficSource || "",
        "capture_location": captureLocation || "",
        "capture_medium": parsedQuery["utm_medium"] || "",
        "capture_campaign": parsedQuery["utm_campaign"] || "",
        "discount_code": (offerDiscountCode) ? 1 : 0,
      },
    }).then(({ data }) => {
      switch(data.userStatus) {
        case "sucessfully_subscribed":
          setSuccess(true)
          if (data.discount_code)
            setDiscountCode(data.discount_code)
          subscribeAnalytics()
          break
        case "already_subscribed":
          setErrorMessage("You’re already signed up.")
          break
        default:
          setErrorMessage("Something happened. Please try again.")
          break
      }
    }).catch(error => {
      console.log(error)
    })
  }
  
  const subscribeAnalytics = () => {
    if (window && window.hasOwnProperty("fbq"))
      window.fbq("track", "Lead")
    if (window && window.hasOwnProperty("ga"))
      trackEvent("Newsletter", "Subscribed", source)
    if (window && window.hasOwnProperty("heap"))
      window.heap.identify(email)
    if (window && window.hasOwnProperty("custoraTrack"))
      window.custoraTrack.identify(email, "")
    window.dataLayer.push({"event":"newsletter_signup"})
  }
  
  const handleNoThanks = () => {
    closeModal()
    trackEvent("Email Capture", "Close", "No Thanks")
  }

  return(
    <>
      {success ?
        <div className={styles.successContainer}>
          {confirmationHeading &&
          <h2 className={styles.heading}>
            {confirmationHeading.heading}
          </h2>
          }
          <p className={styles.success}>
            {offerDiscountCode ?
              <>
                {confirmationTexts[0]}
                <span className="code">{discountCode}</span>
                {confirmationTexts[1]}
              </>
              : confirmationTexts[0]
            }
          </p>
          {confirmationCta &&
          <Button
            color="Dark"
            type="Link"
            url={confirmationCta.url}
          >
            {confirmationCta.text}
          </Button>
          }
        </div>
      :
        <form
          className={styles.form}
          onSubmit={submitEmail}
        >
          {heading &&
            <h2 className={styles.heading}>
              {heading.heading}
            </h2>
          }
          {text &&
            <div className={styles.text}>
              <RichText
                json={text.json}
              />
            </div>
          }
          <input
            type="email"
            placeholder="Your email"
            className={styles.email}
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="submit"
            value={submitText}
            className={styles.submit}
          />
          {errorMessage &&
            <p className={styles.error}>
              {errorMessage}
            </p>
          }
          {disclaimerText &&
            <div className={styles.disclaimer}>
              <RichText
                json={disclaimerText.json}
              />
            </div>
          }
          {closeModal &&
            <button
              className={styles.noThanksBtn}
              onClick={handleNoThanks}
            >No Thanks</button>
          }
        </form>
      }
    </>
  )
}

export default EmailCapture
